import { FooterBranding } from "@/components/PageFooter/FooterBranding";
import { FooterQuickLinks } from "@/components/PageFooter/FooterQuickLinks";
import { FooterSocialLinks } from "@/components/PageFooter/FooterSocialLinks";
import { AppText } from "@/components/Text/AppText";
import { useAppSelector } from "@/hooks/types";
import { getIs1TemplateTenant } from "@/store/tenant/selectors";

export const PageFooter = () => {
    const is1TemplateTenant = useAppSelector(getIs1TemplateTenant);

    return (
        <footer className="mt-6 bg-primary-700 text-white lg:mt-12">
            <div className="mx-auto max-w-7xl px-4 py-8 md:px-8">
                <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                    <FooterBranding />
                    <FooterQuickLinks />
                    <FooterSocialLinks />
                </div>
            </div>

            <div>
                <div className="mx-auto max-w-7xl border-t border-white/20 px-4 py-4 md:px-8">
                    <div className="flex justify-center">
                        <AppText
                            variant="footnote"
                            className="text-xs text-white/75"
                        >
                            © {new Date().getFullYear()}{" "}
                            {is1TemplateTenant
                                ? "1Template"
                                : "Powered By 1Template"}{" "}
                            All Rights Reserved
                        </AppText>
                    </div>
                </div>
            </div>
        </footer>
    );
};
